const getEnvVar = key => {
	if (process.env[key] === undefined) {
		throw new Error(`Env variable ${key} is required`)
	}
	return process.env[key] || ''
}

export const API_SERVER_URL = getEnvVar('REACT_APP_SERVER_URL')
